import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { ErrorsService, safeParseNumber } from 'common';

@Injectable({
  providedIn: "root",
})
export class SubmissionDetailsGuard implements CanActivate {
  constructor(private readonly errorsService: ErrorsService) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const safeParseData = safeParseNumber(route.params?.["id"]);
    if (!safeParseData?.isSuccess) {
      this.errorsService.showNotFoundErrorPage();
      return false;
    }

    return true;
  }
}
